import { resolveApplicationOrigins, type ApplicationOriginEnvironment } from '@/shared/config';

export const isPlatformHost = (
  origin = typeof window === 'undefined' ? '' : window.location.origin,
  environment?: ApplicationOriginEnvironment,
): boolean => {
  let normalizedOrigin: string;

  try {
    normalizedOrigin = new URL(origin.trim()).origin;
  } catch {
    return false;
  }

  return resolveApplicationOrigins(environment).platform.origin === normalizedOrigin;
};
